"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../utils/epsilon-ajax-request");
/**
 * Epsilon Notices Class
 */
var EpsilonNotices = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EpsilonNotices() {
        var self = this;
    }
    /**
     * Initiate notice dismissal
     */
    EpsilonNotices.prototype.init = function () {
        var self = this;
        var notices = jQuery('.epsilon-framework-notice'), id, args, Ajax;
        jQuery.each(notices, function () {
            jQuery(this).on('click', '.notice-dismiss', function () {
                id = jQuery(this).parent().attr('data-unique-id');
                args = {
                    action: ['Epsilon_Notifications', 'dismiss_notice'],
                    nonce: EpsilonWPUrls.ajax_nonce,
                    args: {
                        notice_id: jQuery(this).parent().attr('data-unique-id'),
                        user_id: userSettings.uid,
                    }
                };
                Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
                Ajax.request();
            });
        });
    };
    return EpsilonNotices;
}());
exports.EpsilonNotices = EpsilonNotices;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/admin/notices/notices.ts
// module id = 11
// module chunks = 2